import React, { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { registerRoute } from '@views/Register/route.const'
import {
    AdvantageLine,
    CheckmarkIcon,
    Container,
    CTAText,
    ReasonsContainer,
    ReasonText,
    Subtitle,
    Title
} from './CreateAccountCTA.style'
import { useAuth } from '@context/AuthContext/AuthContext'

interface Props {
    returnUrl?: string
}

const CreateAccountCTA: FC<Props> = ({ returnUrl }) => {
    const { isLoggedIn } = useAuth()
    const { t } = useTranslation()
    const history = useHistory()
    const reasons: string[] = t('accountCreationAd.createAccountCTA.reasons', { returnObjects: true })

    const handleClick = () => {
        if (returnUrl) {
            history.push(`${registerRoute()}?returnUrl=${returnUrl}`)
        } else {
            history.push(registerRoute())
        }
    }

    if (isLoggedIn) {
        return null
    }

    return (
        <Container onClick={handleClick}>
            <div>
                <Title>{t('accountCreationAd.createAccountCTA.title')}</Title>
                <Subtitle>{t('accountCreationAd.createAccountCTA.subtitle')}</Subtitle>
            </div>

            <ReasonsContainer>
                {Array.isArray(reasons) &&
                    reasons.map((reason, index) => (
                        <AdvantageLine key={index}>
                            <CheckmarkIcon className="wemolo-check" />
                            <ReasonText>{reason}</ReasonText>
                        </AdvantageLine>
                    ))}
            </ReasonsContainer>
            <CTAText>{t('accountCreationAd.createAccountCTA.button')}</CTAText>
        </Container>
    )
}

export default CreateAccountCTA
